var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6501 10.4999H18.3751L17.8501 12.5999H13.6501V22.0499H11.5501V12.5999H7.3501V10.4999H11.5501V8.5343C11.5501 6.66215 11.7454 5.9828 12.1108 5.2982C12.4689 4.6218 13.022 4.06866 13.6984 3.7106C14.383 3.3452 15.0623 3.1499 16.9345 3.1499C17.4826 3.1499 17.9635 3.2024 18.3751 3.3074V5.2499H16.9345C15.5443 5.2499 15.1211 5.3318 14.6896 5.5628C14.3704 5.7329 14.1331 5.9702 13.963 6.2894C13.732 6.72095 13.6501 7.1441 13.6501 8.5343V10.4999Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.f5c43a36d5295826030a0290e27bfbf7.svg";
export { ForwardRef as ReactComponent };